import React from 'react';
import { injectIntl } from 'react-intl';
import { Row, Col, Transfer, Spin } from 'antd';
import { connect } from 'dva';
import styles from './styles.less';

class KompassBranches extends React.Component {
  constructor(props) {
    super(props);
    const attrs = {
      parentListData: [],
      childListData: [],
      originalChildListData: [],
      listStyle: {
        width: '100%',
        height: 600,
      },
      dataSource: null,
      showSearch: true,
      searchPlaceholder: this.props.intl.formatMessage({ id: 'Common.SearchHere' }),
      filterOption: (inputValue, option) => {
        return option.title.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      },
      notFoundContent: this.props.intl.formatMessage({ id: 'Common.NotFound' }),
      render: item => item.title,
      selectedBranchesIds: [],
      selectedBranchesData: [],
      onSelectParent: () => {},
      onSelectChild: () => {},
    }
    ;
    this.state = {
      ...attrs,
      ...this.props,
    };
  }

  componentDidMount() {
    this.getKompassBranchesList().then((response) => {
      const data = this.formatTransferArray(response.data);
      this.setState({
        parentListData: data,
      });
    });
  }

  componentWillReceiveProps(nextProps) {
    if (JSON.stringify(this.props.selectedBranchesData) !==
      JSON.stringify(nextProps.selectedBranchesData)) {
      const selectedData = this.formatTransferArray(nextProps.selectedBranchesData);
      const selectedIds = nextProps.selectedBranchesData.map(item => item.id);
      this.setState({
        childListData: selectedData,
        selectedBranchesData: selectedData,
        selectedBranchesIds: selectedIds,
      });
      this.props.onTransfer(selectedIds);
    }
  }

  onSelectParent(selectedItems) {
    const selectedBranchesData = this.state.selectedBranchesData || [];
    if (selectedItems.length) {
      // keep only one selected (behavior like radio buttons)
      const lastSelected = selectedItems[selectedItems.length - 1];
      this.setState({
        selectedParentItems: [lastSelected],
      });
      this.getKompassBranchesList(lastSelected).then((response) => {
        const data = this.formatTransferArray(response.data);
        const filteredSelectedData = selectedBranchesData.filter(
          selectedItem => !data.find(item => item.key === selectedItem.key),
        );
        const childListData = JSON.stringify(selectedBranchesData) !== JSON.stringify(data) ?
          [...data, ...filteredSelectedData] : data;
        this.setState({ childListData, originalChildListData: data });

        if (this.props.setSubBranches) {
          this.props.setSubBranches(response.data);
        }
      });
    }
  }

  onTransferChild(selectedBranchesIds, direction, moveKeys) {
    let childListData = this.state.childListData;
    const selectedBranchesData = this.state.childListData.filter(
      item => selectedBranchesIds.includes(item.key),
    );

    // when moving items from most right column to center column, we have to visually
    // move only the ones which are related to the selected main branch,
    // the other ones should just disappear
    if (direction === 'left') {
      const keysToRemove = moveKeys.filter(
        k => !this.state.originalChildListData.find(origItem => origItem.key === k),
      );
      childListData = this.state.childListData.filter(item => !keysToRemove.includes(item.key));
    }
    this.setState({ selectedBranchesIds, selectedBranchesData, childListData });
    this.props.onTransfer(selectedBranchesIds, direction);
  }

  getKompassBranchesList(id = '[null]') {
    return this.props.dispatch({
      type: 'branches/getKompassBranchesList',
      payload: { id },
    });
  }

  formatTransferArray(data) {
    const formatted = [];
    data.forEach((item) => {
      formatted.push({
        key: item.id,
        title: item.label,
      });
    });
    return formatted;
  }

  render() {
    return (
      <Row type="flex" gutter={4}>
        <Col span={8} className={styles.mainListCol}>
          <h4>{this.state.titles[0]}</h4>
          <Spin spinning={!!this.props.loading.effects['branches/getKompassBranchesList'] && !this.state.parentListData.length}>
            <Transfer
              className={styles.parentList}
              listStyle={{
                width: '100%',
                height: 600,
              }}
              dataSource={this.state.parentListData}
              showSearch={this.state.showSearch}
              searchPlaceholder={this.state.searchPlaceholder}
              filterOption={this.state.filterOption}
              notFoundContent={this.state.notFoundContent}
              render={this.state.render}
              selectedKeys={this.state.selectedParentItems}
              onSelectChange={this.onSelectParent.bind(this)}
            />
          </Spin>
        </Col>
        <Col span={16}>
          <h4 className={styles.transferLeftColumnHeader}>{this.state.titles[1]}</h4>
          <h4 className={styles.transferRightColumnHeader}>{this.state.titles[2]}</h4>
          <Spin spinning={!!this.props.loading.effects['branches/getKompassBranchesList']}>
            {this.props.getFieldDecorator('KOMPASS_BRANCHES_FIELD')(
              <Transfer
                className={styles.childList}
                listStyle={{
                  width: '43%',
                  height: 600,
                }}
                dataSource={this.state.childListData}
                showSearch={this.state.showSearch}
                searchPlaceholder={this.state.searchPlaceholder}
                filterOption={this.state.filterOption}
                targetKeys={this.state.selectedBranchesIds}
                onChange={this.onTransferChild.bind(this)}
                notFoundContent={this.state.notFoundContent}
                render={this.state.render}
              />,
            )}
          </Spin>
        </Col>
      </Row>
    );
  }
}

export default connect(({ loading }) => ({ loading }))(injectIntl(KompassBranches));



// WEBPACK FOOTER //
// ./src/components/KompassBranches/KompassBranches.js